import {BaseEntity, Required} from "../common/base-entity";
import { Address } from '../shared/address';
import {DpBooleanValueTypes, YesNoType} from '../shared/constants';
import {CirfUdf} from "./cirf-udf";

export class CirfMatterContactInfo extends BaseEntity {

    clientCapacity: string;
    postClosingAddress : Address = new Address();
    preClosingAddress : Address = new Address();
    residingAtSubjectProperty : YesNoType ;
    matterContactInfoUdfs : CirfUdf[] = [];

    hasErrors: boolean;


    constructor(cirfMatterContactInfo?: CirfMatterContactInfo) {
        super(cirfMatterContactInfo);
        if(cirfMatterContactInfo){
            if(cirfMatterContactInfo.preClosingAddress){
                this.preClosingAddress = new Address(cirfMatterContactInfo.preClosingAddress);
            }
            if(cirfMatterContactInfo.postClosingAddress){
                this.postClosingAddress = new Address(cirfMatterContactInfo.postClosingAddress);
            }
            this.matterContactInfoUdfs = [];
            if(cirfMatterContactInfo.matterContactInfoUdfs){
                cirfMatterContactInfo.matterContactInfoUdfs.forEach((udf)=>{
                    this.matterContactInfoUdfs.push(new CirfUdf(udf));
                });
            }
        }

        if(!this.residingAtSubjectProperty){
            this.residingAtSubjectProperty = '';
        }
        if(!this.clientCapacity || this.clientCapacity == 'UNSPECIFIED_CAPACITY'){
            this.clientCapacity  = '';
        }
    }

    isClientCapacityEmpty() : boolean {
        return this.clientCapacity == '';
    }

    isClientCapacityIDontKnow() : boolean {
        return this.clientCapacity == 'I_DONT_KNOW';
    }

    isClientCapacityOther() : boolean {
        return this.clientCapacity == 'OTHER';
    }

    get entityName() : string {
        return 'matterContactInfo';
    }
}
